<template>
  <div class="flex flex-col items-center justify-center h-screen">
    <img
      src="https://storage.googleapis.com/komerce/assets/logo/logo-komerce-no-tag.svg"
      alt="logo"
      width="176px"
      class="mb-[40px]"
    >
    <h1 class="text-2xl font-semibold text-center">
      Integrasi Marketplace Berhasil 🎉
    </h1>
    <p class="text-sm text-gray-500 text-center mb-[40px] max-w-[500px]">
      Sekarang Toko mu telah terintegrasi dengan sistem Komerce. Lakukan mapping produk dengan produk di Tokomu agar produkmu tersinkronisasi dengan sistem Kompack.
    </p>
    <p class="text-sm text-gray-500 text-center max-w-[500px]">
      Halaman akan tertutup otomatis dalam <span class="font-semibold">{{ countdown }}</span> detik.
    </p>
    <p class="text-sm text-gray-500 text-center max-w-[500px]">
      Apabila setelah hitung mundur selesai halaman tidak tertutup otomatis, silahkan tutup halaman ini secara manual.
    </p>
  </div>
</template>

<script>
export default {
  name: 'IntegratedSuccesfullyPage',
  data() {
    return {
      countdown: 5,
    }
  },
  mounted() {
    this.startCountdown()
  },
  methods: {
    /**
     * Start the countdown to close the page
     */
    startCountdown() {
      this.notifyParent()
      const interval = setInterval(() => {
        this.countdown -= 1
        if (this.countdown <= 0) {
          clearInterval(interval)
          if (window.close) {
            window.close()
          }
        }
      }, 1000)
    },
    /**
     * Notify the parent window that the integration is successful
     */
    notifyParent() {
      try {
        const bc = new BroadcastChannel('marketplace_integration')
        bc.postMessage({
          type: 'INTEGRATION_SUCCESS',
          data: {
            integration_success: true,
          },
        })
        bc.close()
      } catch (e) {
        console.error('BroadcastChannel error:', e)
      }
    },
  },
}
</script>
